import { useEffect } from "react";
import { Controller, useWatch } from "react-hook-form";

import { CCard, CCardBody } from "@coreui/react";

export const MobileSumRow = ({ control, setValue }) => {
  const materials = useWatch({ control, name: "materials" });

  useEffect(() => {
    const quantity = materials.reduce(
      (prev, curr) => prev + (curr?.wareQ || 0),
      0,
    );
    setValue("quantity", quantity);

    const total = materials.reduce(
      (prev, curr) => prev + (curr?.warePrice || 0) * (curr?.wareQ || 0),
      0,
    );
    setValue("value", total);
  }, [materials]);

  return (
    <CCard
      className="toolbar sticky"
      style={{ top: "unset!important", bottom: 0 }}
    >
      <CCardBody>
        <div className="flex items-center">
          <span className="font-bold flex-[0.4]">Tổng</span>
          <Controller
            control={control}
            name={`quantity`}
            render={({ field }) => (
              <span className="font-bold flex-[0.3]">{`${field.value} NVL`}</span>
            )}
          />
          <Controller
            control={control}
            name={`value`}
            render={({ field }) => (
              <span className="font-bold flex-[0.3]">
                {field.value?.toLocaleString("en-US")}
              </span>
            )}
          />
        </div>
      </CCardBody>
    </CCard>
  );
};
